import KinerjaKonfirmasiProfilApp from 'app/KinerjaPage/pages/KonfirmasiProfil'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PageGuardPamong } from 'app/KinerjaPamongPage/components/PageGuardPamong'
import { useAPIKinerja } from 'api/kinerja/useAPIKinerja'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-spnf-enabled'] || false

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }

    return { props: {} }
  },
})

const KinerjaKonfirmasiProfil = () => {
  const {
    data: { data: skp } = {},
    isFetched: isSKPFetched,
    isLoading: isSKPLoading,
  } = useAPIKinerja(undefined, {
    role: 'GURU_SPNF',
  })

  return (
    <KinerjaKonfirmasiProfilApp
      skipEditConfirmation
      skp={skp}
      isSKPFetched={isSKPFetched}
      isSKPLoading={isSKPLoading}
      role="GURU_SPNF"
    />
  )
}

const KinerjaKonfirmasiProfilPamong = () => (
  <PageGuardPamong>
    <KinerjaKonfirmasiProfil />
  </PageGuardPamong>
)

KinerjaKonfirmasiProfilPamong.Layout = KinerjaLayout

KinerjaKonfirmasiProfilPamong.layoutOpts = {
  className: 'text-default bg-gray-10 !max-w-full !h-full min-h-screen',
}

export default KinerjaKonfirmasiProfilPamong
